// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 钱包消费明细分页列表查询
export const _findRecordByPage = (params) => {
    return getRequest('/registerEwallet/findRecordByPage', params)
}
// 用户钱包信息
export const _findOne = (params) => {
    return getRequest('/registerEwallet/findOne', params)
}
//提现
export const _saveMoney = (params) => {
    return postRequest('/vo/save', params)
}
//提现明细
export const _getByPage = (params) => {
    return getRequest('/vo/getByPage', params)
}
//用户登录记录接口
export const _getLogn = (params) => {
    return getRequest('/registerInoutLog/getByPage', params)
}
// 红包余额
export const _getFindOne = (params) => {
    return getRequest('/registerRedEnvelope/findOne', params)
}
// 红包明细
export const _getRedEnvelope = (params) => {
    return getRequest('/registerRedEnvelope/findRecordByPage', params)
}
// 钱包充值接口
export const _getrecharge = (params) => {
    return postRequest('/registerEwallet/recharge', params)
}
// 校验核验码
export const _getVerifyCode = (params) => {
    return getRequest('/verifyOperation/verifyCode', params)
}
//获取公示信息接口
export const _getVerifyInfo = (params) => {
    return getRequest('/disclosure/get', params)
}
//核验证书编码
export const _getByEvidenceArchiveCertNumber = (params) => {
    return getRequest('/disclosure/getByEvidenceArchiveCertNumber', params)
}
//成就详情
export const _getValidByPage = (params) => {
    return getRequest('/registerInviteCommission/getValidByPage', params)
}
//新增转账到钱包申请
export const _drawMoney = (params) => {
    return postRequest('/registerInviteCommission/drawMoney', params)
}
//个人中心输入邀请码
export const _inputInviteCode = (params) => {
    return getRequest('/registerInviteCode/inputInviteCode', params)
}
//预存账户消费明细
export const _getPreList = (params) => {
    return getRequest('/registerPreRecharge/findRecordByPage', params)
}